import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { PerthNowSection } from '@news-mono/component-library'
import { StaticRoutes } from '@news-mono/web-common'
import { createCngFacebookBannerComponent } from '../lib/create-cng-facebook-banner-component'
import { mandurahTimesBanner } from '../mandurah-times/mandurahTimesBanner'
import { communityNewsCompetitionsPage } from './get-community-news-competition-page'
import { communityNewsHomepage } from './get-community-news-homepage'
import { communityNewsMasthead } from './get-community-news-masthead-landing-page'
import { communityNewsRegion } from './get-community-news-region-landing-page'

export const communityNewsTopics = {
    cityWest: [
        'community-news/city-west',
        'community-news/stirling-times',
        'community-news/western-suburbs-weekly',
    ],
    hillsEast: [
        'community-news/hills-east',
        'community-news/eastern-reporter',
        'community-news/the-advocate',
        'community-news/midland-kalamunda-reporter',
        'community-news/hills-avon-valley-gazette',
    ],
    north: [
        'community-news/north',
        'community-news/joondalup-times',
        'community-news/wanneroo-times',
        'community-news/north-coast-times',
    ],
    south: [
        'community-news/south',
        'community-news/canning-gazette',
        'community-news/cockburn-gazette',
        'community-news/comment-news',
        'community-news/fremantle-gazette',
        'community-news/melville-gazette',
        'community-news/southern-gazette',
    ],
    southCoast: [
        'community-news/south-coast',
        'community-news/mandurah-times',
        'community-news/weekend-kwinana-courier',
    ],
}

export type CngMasthead =
    | 'western-suburbs-weekly'
    | 'stirling-times'
    | 'eastern-reporter'
    | 'hills-avon-valley-gazette'
    | 'midland-kalamunda-reporter'
    | 'the-advocate'
    | 'joondalup-times'
    | 'north-coast-times'
    | 'wanneroo-times'
    | 'canning-gazette'
    | 'cockburn-gazette'
    | 'comment-news'
    | 'fremantle-gazette'
    | 'melville-gazette'
    | 'southern-gazette'
    | 'mandurah-times'
    | 'weekend-kwinana-courier'

export const communityNews: StaticRoutes<PerthNowSection> = {
    '/community-news': ({ config, getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )

        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsHomepage({
            config,
            getAdTargeting,
        })
    },
    // CNG Regions Listing Pages ( one region = many mastheads )
    '/community-news/city-west': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )

        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/central',
                    httpStatusCode: 301,
                },
            }
        }
        return communityNewsRegion({
            getAdTargeting,
            region: {
                id: 'community-news/city-west',
                title: 'City/West',
                description:
                    'The Latest Community news in the City/West Region',
            },
            topics: communityNewsTopics.cityWest,
        })
    },
    '/community-news/hills-east': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )

        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/central',
                    httpStatusCode: 301,
                },
            }
        }
        return communityNewsRegion({
            getAdTargeting,
            region: {
                id: 'community-news/hills-east',
                title: 'Hills/East',
                description:
                    'The Latest Community news in the Hills/East Region',
            },
            topics: communityNewsTopics.hillsEast,
        })
    },
    '/community-news/north': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )

        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/north',
                    httpStatusCode: 301,
                },
            }
        }
        return communityNewsRegion({
            getAdTargeting,
            region: {
                id: 'community-news/north',
                title: 'North',
                description: 'The Latest Community news in the North Region',
            },
            topics: communityNewsTopics.north,
        })
    },
    '/community-news/south': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )

        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/south',
                    httpStatusCode: 301,
                },
            }
        }
        return communityNewsRegion({
            getAdTargeting,
            region: {
                id: 'community-news/south',
                title: 'South',
                description: 'The Latest Community news in the South Region',
            },
            topics: communityNewsTopics.south,
        })
    },
    '/community-news/south-coast': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/south',
                    httpStatusCode: 301,
                },
            }
        }
        return communityNewsRegion({
            getAdTargeting,
            region: {
                id: 'community-news/south-coast',
                title: 'South Coast',
                description:
                    'The Latest Community news in the South Coast Region',
            },
            topics: communityNewsTopics.southCoast,
        })
    },

    '/community-news/western-suburbs-weekly': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )

        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-western-suburbs',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/western-suburbs-weekly',
                title: 'Western Suburbs Weekly',
                description: `Latest local Perth news, lifestyle, sport, motoring & real estate for families, residents & businesses in Perth's Western Suburbs.`,
            },
            topics: ['community-news/western-suburbs-weekly'],
            facebookBanner: createCngFacebookBannerComponent(
                'western-suburbs-weekly',
            ),
        })
    },
    '/community-news/stirling-times': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-stirling',
                    httpStatusCode: 301,
                },
            }
        }
        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/stirling-times',
                title: 'Stirling Times',
                description: `Latest local Stirling news, opinion, lifestyle, sport, motoring & real estate for families, residents & businesses in the City of Stirling.`,
            },
            topics: ['community-news/stirling-times'],
            facebookBanner: createCngFacebookBannerComponent('stirling-times'),
        })
    },
    '/community-news/eastern-reporter': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-central',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/eastern-reporter',
                title: 'Eastern Reporter',
                description: `Latest local Perth news, lifestyle, sport, motoring & real estate for families, residents & businesses in Perth's Eastern Suburbs.`,
            },
            topics: ['community-news/eastern-reporter'],
            facebookBanner:
                createCngFacebookBannerComponent('eastern-reporter'),
        })
    },
    '/community-news/hills-avon-valley-gazette': ({
        getAdTargeting,
        store,
    }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-central',
                    httpStatusCode: 301,
                },
            }
        }
        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/hills-avon-valley-gazette',
                title: 'Hills Avon Valley Gazette',
                description: `Latest local news, lifestyle, sport, motoring and real estate for families, residents and businesses in the Avon Valley.`,
            },
            topics: ['community-news/hills-avon-valley-gazette'],
            facebookBanner: createCngFacebookBannerComponent(
                'hills-avon-valley-gazette',
            ),
        })
    },
    '/community-news/midland-kalamunda-reporter': ({
        getAdTargeting,
        store,
    }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-central',
                    httpStatusCode: 301,
                },
            }
        }
        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/midland-kalamunda-reporter',
                title: 'Midland Kalamunda Reporter',
                description: `Latest local news, lifestyle, sport, motoring and real estate for families, residents and businesses in Midland, Kalamunda and Perth Hills.`,
            },
            topics: ['community-news/midland-kalamunda-reporter'],
            facebookBanner: createCngFacebookBannerComponent(
                'midland-kalamunda-reporter',
            ),
        })
    },
    '/community-news/the-advocate': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-central',
                    httpStatusCode: 301,
                },
            }
        }
        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/the-advocate',
                title: 'The Advocate',
                description: `Latest local Ellenbrook news, opinion, lifestyle, sport, motoring and real estate for families, residents and businesses in the City of Swan.`,
            },
            topics: ['community-news/the-advocate'],
            facebookBanner: createCngFacebookBannerComponent('the-advocate'),
        })
    },
    '/community-news/joondalup-times': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-joondalup',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/joondalup-times',
                title: 'Joondalup Times',
                description: `Latest local Joondalup news, opinion, lifestyle, sport, motoring & real estate for families, residents & businesses in City of Joondalup.`,
            },
            topics: ['community-news/joondalup-times'],
            facebookBanner: createCngFacebookBannerComponent('joondalup-times'),
        })
    },
    '/community-news/north-coast-times': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-joondalup',
                    httpStatusCode: 301,
                },
            }
        }
        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/north-coast-times',
                title: 'North Coast Times',
                description: `Latest local news, lifestyle, sport, motoring and real estate for families, residents and businesses in Perth's North Coast.`,
            },
            topics: ['community-news/north-coast-times'],
            facebookBanner:
                createCngFacebookBannerComponent('north-coast-times'),
        })
    },
    '/community-news/wanneroo-times': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-wanneroo',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/wanneroo-times',
                title: 'Wanneroo Times',
                description: `Latest local Wanneroo news, opinion, lifestyle, sport, motoring & real estate for families, residents & businesses in the City of Wanneroo.`,
            },
            topics: ['community-news/wanneroo-times'],
            facebookBanner: createCngFacebookBannerComponent('wanneroo-times'),
        })
    },
    '/community-news/canning-gazette': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-canning',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/canning-gazette',
                title: 'Canning Gazette',
                description: `Latest local Canning news, opinion, lifestyle, sport, motoring and real estate for families, residents and businesses in the City of Canning.`,
            },
            topics: ['community-news/canning-gazette'],
            facebookBanner: createCngFacebookBannerComponent('canning-gazette'),
        })
    },
    '/community-news/cockburn-gazette': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-cockburn',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/cockburn-gazette',
                title: 'Cockburn Gazette',
                description: `Latest local Cockburn news, opinion, lifestyle, sport, motoring & real estate for families, residents & businesses in the City of Cockburn.`,
            },
            topics: ['community-news/cockburn-gazette'],
            facebookBanner:
                createCngFacebookBannerComponent('cockburn-gazette'),
        })
    },
    '/community-news/comment-news': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-central',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/comment-news',
                title: 'Comment News',
                description: `Latest local news, lifestyle, sport, motoring & real estate for families, residents & businesses in City of Gosnells & City of Armadale.`,
            },
            topics: ['community-news/comment-news'],
            facebookBanner: createCngFacebookBannerComponent('comment-news'),
        })
    },
    '/community-news/fremantle-gazette': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-fremantle',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/fremantle-gazette',
                title: 'Fremantle Gazette',
                description: `Latest local news, lifestyle, sport, motoring & real estate for families, residents & businesses in City of Fremantle & East Fremantle.`,
            },
            topics: ['community-news/fremantle-gazette'],
            facebookBanner:
                createCngFacebookBannerComponent('fremantle-gazette'),
        })
    },
    '/community-news/melville-gazette': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-melville',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/melville-gazette',
                title: 'Melville Gazette',
                description: `Latest local Melville news, opinion, lifestyle, sport, motoring & real estate for families, residents & businesses in the City of Melville.`,
            },
            topics: ['community-news/melville-gazette'],
            facebookBanner:
                createCngFacebookBannerComponent('melville-gazette'),
        })
    },
    '/community-news/southern-gazette': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-southern',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/southern-gazette',
                title: 'Southern Gazette',
                description: `Latest local news, lifestyle, sport & real estate for residents & businesses in the City of Belmont, City of South Perth & Victoria Park.`,
            },
            topics: ['community-news/southern-gazette'],
            facebookBanner:
                createCngFacebookBannerComponent('southern-gazette'),
        })
    },
    '/community-news/mandurah-times': ({ getAdTargeting }) => {
        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/mandurah-times',
                title: 'Mandurah Times',
                description: `Latest local news, opinion, lifestyle, sport, motoring and real estate for families, residents and businesses in City of Mandurah.`,
            },
            topics: ['community-news/mandurah-times'],
            facebookBanner: createCngFacebookBannerComponent('mandurah-times'),
            showLocalNewsBanner: false,
            banner: mandurahTimesBanner,
        })
    },
    '/community-news/weekend-kwinana-courier': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/perthnow-cockburn',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsMasthead({
            getAdTargeting,
            region: {
                id: 'community-news/weekend-kwinana-courier',
                title: 'Weekend Kwinana Courier',
                description: `Latest local news, lifestyle, sport, motoring and real estate for families, residents and businesses in Rockingham and Kwinana.`,
            },
            topics: ['community-news/weekend-kwinana-courier'],
            facebookBanner: createCngFacebookBannerComponent(
                'weekend-kwinana-courier',
            ),
        })
    },
    '/community-news/competitions': ({ getAdTargeting, store }) => {
        const showCommunityPage = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'community-news',
        )
        if (!showCommunityPage) {
            return {
                kind: 'redirect',
                redirectTo: {
                    targetUrl: '/local-news/competitions',
                    httpStatusCode: 301,
                },
            }
        }

        return communityNewsCompetitionsPage({ getAdTargeting })
    },
}
